"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeBase64 = exports.encodeBase64 = exports.getMD5Hash = void 0;
const md5 = require("md5");
function getMD5Hash(input) {
    return md5(input);
}
exports.getMD5Hash = getMD5Hash;
function encodeBase64(input) {
    return Buffer.from(input, 'utf8').toString('base64');
}
exports.encodeBase64 = encodeBase64;
function decodeBase64(input) {
    return Buffer.from(input, 'base64').toString('utf8');
}
exports.decodeBase64 = decodeBase64;
//# sourceMappingURL=obfuscation.js.map